// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MonthItem-module__font-s-10___dcbWl {
  font-size: 10px !important;
}

.MonthItem-module__font-s-12___UsDJn {
  font-size: 12px !important;
}

.MonthItem-module__font-s-13___qvH63 {
  font-size: 13px !important;
}

.MonthItem-module__font-s-14___6p7i2 {
  font-size: 14px !important;
}

.MonthItem-module__font-s-15___y5a31 {
  font-size: 15px !important;
}

.MonthItem-module__font-s-16___GvNFL {
  font-size: 16px !important;
}

.MonthItem-module__font-s-18___t305G {
  font-size: 18px !important;
}

.MonthItem-module__font-s-20___Tz_0Y {
  font-size: 20px !important;
}

.MonthItem-module__font-s-22___aCH2d {
  font-size: 22px !important;
}

.MonthItem-module__font-s-28___lmENX {
  font-size: 28px !important;
}

.MonthItem-module__font-w-400___uKt73 {
  font-weight: 400 !important;
}

.MonthItem-module__font-w-500___H9w0p {
  font-weight: 500 !important;
}

.MonthItem-module__font-w-600___CEJzY {
  font-weight: 600 !important;
}

.MonthItem-module__font-w-700___sus4q {
  font-weight: 700 !important;
}

.MonthItem-module__p-5___XIyiD {
  padding: 5px !important;
}

.MonthItem-module__p-12___Mluy_ {
  padding: 12px !important;
}

.MonthItem-module__p-16___lti1K {
  padding: 16px !important;
}

.MonthItem-module__p-30___pwxdp {
  padding: 30px !important;
}

.MonthItem-module__p-b-0___qU3as {
  padding-bottom: 0 !important;
}

.MonthItem-module__p-b-5___xP6F4 {
  padding-bottom: 5px !important;
}

.MonthItem-module__p-b-10___UEJn6 {
  padding-bottom: 10px !important;
}

.MonthItem-module__p-b-12___Dr3r2 {
  padding-bottom: 12px !important;
}

.MonthItem-module__p-b-16___fgBKX {
  padding-bottom: 16px !important;
}

.MonthItem-module__p-b-18___ctGPS {
  padding-bottom: 18px !important;
}

.MonthItem-module__p-b-20___O6zKZ {
  padding-bottom: 20px !important;
}

.MonthItem-module__p-b-25___AsyGg {
  padding-bottom: 25px !important;
}

.MonthItem-module__p-b-30___ayaQA {
  padding-bottom: 30px !important;
}

.MonthItem-module__p-b-50___sV2FV {
  padding-bottom: 50px !important;
}

.MonthItem-module__p-t-0___aV9TG {
  padding-top: 0 !important;
}

.MonthItem-module__p-t-12___Qi8_d {
  padding-top: 12px !important;
}

.MonthItem-module__p-t-16___eb5le {
  padding-top: 16px !important;
}

.MonthItem-module__p-t-18___eeX23 {
  padding-top: 18px !important;
}

.MonthItem-module__p-t-20___C7jhW {
  padding-top: 20px !important;
}

.MonthItem-module__p-t-30___q2zyi {
  padding-top: 30px !important;
}

.MonthItem-module__p-t-40___Pb5ri {
  padding-top: 40px !important;
}

.MonthItem-module__p-t-50___olj2R {
  padding-top: 50px !important;
}

.MonthItem-module__p-l-20___ntvLb {
  padding-left: 20px !important;
}

.MonthItem-module__p-l-30___nToPk {
  padding-left: 30px !important;
}

.MonthItem-module__p-l-40___kVDjp {
  padding-left: 40px !important;
}

.MonthItem-module__p-r-16___hCIb5 {
  padding-right: 16px !important;
}

.MonthItem-module__p-r-20___u4US0 {
  padding-right: 20px !important;
}

.MonthItem-module__p-r-30___XSAac {
  padding-right: 30px !important;
}

.MonthItem-module__p-r-50___WIyZe {
  padding-right: 50px !important;
}

.MonthItem-module__p-r-60___S7_5t {
  padding-right: 60px !important;
}

.MonthItem-module__m-b-1___gFb5t {
  margin-bottom: 1px !important;
}

.MonthItem-module__m-b-2___SX6aB {
  margin-bottom: 2px !important;
}

.MonthItem-module__m-b-6___wZ3R6 {
  margin-bottom: 6px !important;
}

.MonthItem-module__m-b-8___MO2y3 {
  margin-bottom: 8px !important;
}

.MonthItem-module__m-b-10___SOGiM {
  margin-bottom: 10px !important;
}

.MonthItem-module__m-b-14___d5MGx {
  margin-bottom: 14px !important;
}

.MonthItem-module__m-b-16___CfPqV {
  margin-bottom: 16px !important;
}

.MonthItem-module__m-b-20___yhNxM {
  margin-bottom: 20px !important;
}

.MonthItem-module__m-b-22___UUswA {
  margin-bottom: 22px !important;
}

.MonthItem-module__m-b-24___TowH9 {
  margin-bottom: 24px !important;
}

.MonthItem-module__m-b-30___eQixV {
  margin-bottom: 30px !important;
}

.MonthItem-module__m-b-32___nPIem {
  margin-bottom: 32px !important;
}

.MonthItem-module__m-b-40___Gf49g {
  margin-bottom: 40px !important;
}

.MonthItem-module__m-t-2___UOPsT {
  margin-top: 2px !important;
}

.MonthItem-module__m-t-3___u689b {
  margin-top: 3px !important;
}

.MonthItem-module__m-t-4___bSs3s {
  margin-top: 4px !important;
}

.MonthItem-module__m-t-5___bowIo {
  margin-top: 5px !important;
}

.MonthItem-module__m-t-8___hCX5E {
  margin-top: 8px !important;
}

.MonthItem-module__m-t-10___iQLUz {
  margin-top: 10px !important;
}

.MonthItem-module__m-t-15___NE24E {
  margin-top: 15px !important;
}

.MonthItem-module__m-t-16___y1aGi {
  margin-top: 16px !important;
}

.MonthItem-module__m-t-20___ufv71 {
  margin-top: 20px !important;
}

.MonthItem-module__m-t-22___YuqgK {
  margin-top: 22px !important;
}

.MonthItem-module__m-t-30___jP0h6 {
  margin-top: 30px !important;
}

.MonthItem-module__m-t-32___UtqhJ {
  margin-top: 32px !important;
}

.MonthItem-module__m-l-auto___Dk7Wy {
  margin-left: auto !important;
}

.MonthItem-module__m-l-4___Rhd2O {
  margin-left: 4px !important;
}

.MonthItem-module__m-l-5___Z_XSq {
  margin-left: 5px !important;
}

.MonthItem-module__m-l-6___NLfGu {
  margin-left: 6px !important;
}

.MonthItem-module__m-l-8___BXl6f {
  margin-left: 8px !important;
}

.MonthItem-module__m-l-10___M7rBK {
  margin-left: 10px !important;
}

.MonthItem-module__m-l-16___CqtHu {
  margin-left: 16px !important;
}

.MonthItem-module__m-l-20___ECljO {
  margin-left: 20px !important;
}

.MonthItem-module__m-l-24___pS7x1 {
  margin-left: 24px !important;
}

.MonthItem-module__m-l-30___h_FzD {
  margin-left: 30px !important;
}

.MonthItem-module__m-l-35___RSqVo {
  margin-left: 35px !important;
}

.MonthItem-module__m-l-40___ARWUN {
  margin-left: 40px !important;
}

.MonthItem-module__m-r-8___kVDlv {
  margin-right: 8px !important;
}

.MonthItem-module__m-r-10___RE0zG {
  margin-right: 10px !important;
}

.MonthItem-module__m-r-16___M3tQo {
  margin-right: 16px !important;
}

.MonthItem-module__m-r-20___ozwCU {
  margin-right: 20px !important;
}

.MonthItem-module__m-r-24___osbuY {
  margin-right: 24px !important;
}

.MonthItem-module__m-r-30___THEQ9 {
  margin-right: 30px !important;
}

.MonthItem-module__m-r-40___Z3P_B {
  margin-right: 40px !important;
}

.MonthItem-module__border-r-3___qKBvk {
  border-radius: 3px !important;
}

.MonthItem-module__border-r-4___qQZKD {
  border-radius: 4px !important;
}

.MonthItem-module__border-r-6___n34vv {
  border-radius: 6px !important;
}

.MonthItem-module__border-r-10___j6isk {
  border-radius: 10px !important;
}

.MonthItem-module__border-r-12___th6nA {
  border-radius: 12px !important;
}

.MonthItem-module__border-r-16___ESsFB {
  border-radius: 16px !important;
}

.MonthItem-module__border-r-50___GXEN_ {
  border-radius: 50% !important;
}

.MonthItem-module__primary-border___QYnnj {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.MonthItem-module__primary-border-b___AwTe0 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.MonthItem-module__primary-border-t___GNTQm {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.MonthItem-module__primary-border-l___tTarM {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.MonthItem-module__primary-border-r___Hs6Ne {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.MonthItem-module__secondary-border___AGm5J {
  border: 1px solid #637768;
}

.MonthItem-module__secondary-border-b___NyVc1 {
  border-bottom: 1px solid #637768;
}

.MonthItem-module__secondary-border-t___oWa8E {
  border-top: 1px solid #637768;
}

.MonthItem-module__secondary-border-l___Sd6w2 {
  border-left: 1px solid #637768;
}

.MonthItem-module__secondary-border-r___REDNF {
  border-right: 1px solid #637768;
}

.MonthItem-module__gap-0___sslJH {
  gap: 0 !important;
}

.MonthItem-module__gap-2___RpqM6 {
  gap: 2px !important;
}

.MonthItem-module__gap-4___BEnMZ {
  gap: 4px !important;
}

.MonthItem-module__gap-5___Ze6Ge {
  gap: 5px !important;
}

.MonthItem-module__gap-6___eS_0Q {
  gap: 6px !important;
}

.MonthItem-module__gap-8___ozYBK {
  gap: 8px !important;
}

.MonthItem-module__gap-10___UXZAV {
  gap: 10px !important;
}

.MonthItem-module__gap-12___EUH8D {
  gap: 12px !important;
}

.MonthItem-module__gap-14___DAgbR {
  gap: 14px !important;
}

.MonthItem-module__gap-16___jxxIg {
  gap: 16px !important;
}

.MonthItem-module__gap-18___tB136 {
  gap: 18px !important;
}

.MonthItem-module__gap-20___mfI1_ {
  gap: 20px !important;
}

.MonthItem-module__gap-24___T9Dt3 {
  gap: 24px !important;
}

.MonthItem-module__gap-26___KdlXt {
  gap: 26px !important;
}

.MonthItem-module__gap-30___k6Zvw {
  gap: 30px !important;
}

.MonthItem-module__gap-32___O_FED {
  gap: 32px !important;
}

.MonthItem-module__gap-40___fmBPR {
  gap: 40px !important;
}

.MonthItem-module__gap-50___gUmXF {
  gap: 50px !important;
}

.MonthItem-module__flex-1___dASnh {
  flex: 1;
}

.MonthItem-module__flex-none___SsuNi {
  flex: none !important;
}

.MonthItem-module__flex-column___ytLdq {
  display: flex;
  flex-direction: column !important;
}

.MonthItem-module__flex-row___RQesn {
  display: flex;
  flex-direction: row !important;
}

.MonthItem-module__vertically-centered___TeEW9 {
  display: flex;
  align-items: center !important;
}

.MonthItem-module__horizontally-centered___kqzsp {
  display: flex;
  justify-content: center !important;
}

.MonthItem-module__horizontally-end___duTnX {
  display: flex;
  justify-content: end !important;
}

.MonthItem-module__vertically-start___KCEFU {
  display: flex;
  align-items: start !important;
}

.MonthItem-module__space-between___o9XW2 {
  display: flex;
  justify-content: space-between !important;
}

.MonthItem-module__flex-wrap___ELxPF {
  flex-wrap: wrap !important;
}

.MonthItem-module__height-100___wcUwb {
  height: 100%;
}

.MonthItem-module__width-50___lgm64 {
  width: 50% !important;
}

.MonthItem-module__width-100___hTOSq {
  width: 100%;
}

.MonthItem-module__cursor-pointer___YK0Wl {
  cursor: pointer;
}

.MonthItem-module__cursor-not-allowed___qTQp0 {
  cursor: not-allowed !important;
}

.MonthItem-module__absolute-centered___v0FD4 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.MonthItem-module__absolute___E27Gg {
  position: absolute;
}

.MonthItem-module__relative___goBhR {
  position: relative;
}

.MonthItem-module__fixed___BOsF2 {
  position: fixed;
}

.MonthItem-module__visible___IichU {
  opacity: 1;
}

.MonthItem-module__invisible___Axxt3 {
  opacity: 0;
}

.MonthItem-module__col-90___ohpEA {
  width: 90% !important;
}

.MonthItem-module__col-auto___RQX0D {
  width: auto !important;
}

.MonthItem-module__medical-tabs___e6MDi {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.MonthItem-module__medical-table-new___oZGtR {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MonthItem-module__medical-table-new___oZGtR:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MonthItem-module__medical-table-new___oZGtR::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MonthItem-module__medical-table-new___oZGtR::-webkit-scrollbar-track {
  display: none;
}
.MonthItem-module__medical-table-new___oZGtR.MonthItem-module__no-pagination___YAEPj {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MonthItem-module__medical-table-new___oZGtR.MonthItem-module__no-pagination___YAEPj:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MonthItem-module__medical-table-new___oZGtR.MonthItem-module__no-pagination___YAEPj::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MonthItem-module__medical-table-new___oZGtR.MonthItem-module__no-pagination___YAEPj::-webkit-scrollbar-track {
  display: none;
}

.MonthItem-module__medical-table-empty___lhaah {
  padding: 14px 40px !important;
}

.MonthItem-module__icon-btn___vy6Lv {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.MonthItem-module__search-icon___iipXX {
  width: 24px;
  height: 24px;
  align-self: center;
}

.MonthItem-module__disable-select___xUVWl {
  user-select: none;
}

.MonthItem-module__break-word___sWpfh {
  word-break: break-word;
}

.MonthItem-module__popup-clear-btn___jPiGs {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.MonthItem-module__scroll-m-b-20___PvYIT {
  scroll-margin-bottom: 20px;
}

.MonthItem-module__item___OZvPi {
  padding: 21px 100px;
  position: relative;
}
.MonthItem-module__item___OZvPi .MonthItem-module__circle___hD_yo {
  border: 1px solid #859989;
  border-radius: 50%;
  position: absolute;
  display: block;
  height: 17px;
  width: 17px;
  left: 44px;
  top: 30px;
}
.MonthItem-module__item___OZvPi .MonthItem-module__circle___hD_yo.MonthItem-module__fill___HjR29 {
  background-color: #859989;
}
.MonthItem-module__item___OZvPi .MonthItem-module__month___MpGYm {
  color: #375844;
  font-size: 24px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Labs/items/MonthItem/MonthItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,mBAAA;EACA,kBAAA;AA8pBF;AA5pBE;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;AA8pBJ;AA5pBI;EACE,yBAAA;AA8pBN;AA1pBE;EACE,cAAA;EACA,eAAA;AA4pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.item {\n  padding: 21px 100px;\n  position: relative;\n\n  .circle {\n    border: 1px solid get-color(greenNew, medium);\n    border-radius: 50%;\n    position: absolute;\n    display: block;\n    height: 17px;\n    width: 17px;\n    left: 44px;\n    top: 30px;\n\n    &.fill {\n      background-color: get-color(greenNew, medium);\n    }\n  }\n\n  .month {\n    color: get-color(greenNew, dark);\n    font-size: 24px;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `MonthItem-module__font-s-10___dcbWl`,
	"fontS12": `MonthItem-module__font-s-12___UsDJn`,
	"fontS13": `MonthItem-module__font-s-13___qvH63`,
	"fontS14": `MonthItem-module__font-s-14___6p7i2`,
	"fontS15": `MonthItem-module__font-s-15___y5a31`,
	"fontS16": `MonthItem-module__font-s-16___GvNFL`,
	"fontS18": `MonthItem-module__font-s-18___t305G`,
	"fontS20": `MonthItem-module__font-s-20___Tz_0Y`,
	"fontS22": `MonthItem-module__font-s-22___aCH2d`,
	"fontS28": `MonthItem-module__font-s-28___lmENX`,
	"fontW400": `MonthItem-module__font-w-400___uKt73`,
	"fontW500": `MonthItem-module__font-w-500___H9w0p`,
	"fontW600": `MonthItem-module__font-w-600___CEJzY`,
	"fontW700": `MonthItem-module__font-w-700___sus4q`,
	"p5": `MonthItem-module__p-5___XIyiD`,
	"p12": `MonthItem-module__p-12___Mluy_`,
	"p16": `MonthItem-module__p-16___lti1K`,
	"p30": `MonthItem-module__p-30___pwxdp`,
	"pB0": `MonthItem-module__p-b-0___qU3as`,
	"pB5": `MonthItem-module__p-b-5___xP6F4`,
	"pB10": `MonthItem-module__p-b-10___UEJn6`,
	"pB12": `MonthItem-module__p-b-12___Dr3r2`,
	"pB16": `MonthItem-module__p-b-16___fgBKX`,
	"pB18": `MonthItem-module__p-b-18___ctGPS`,
	"pB20": `MonthItem-module__p-b-20___O6zKZ`,
	"pB25": `MonthItem-module__p-b-25___AsyGg`,
	"pB30": `MonthItem-module__p-b-30___ayaQA`,
	"pB50": `MonthItem-module__p-b-50___sV2FV`,
	"pT0": `MonthItem-module__p-t-0___aV9TG`,
	"pT12": `MonthItem-module__p-t-12___Qi8_d`,
	"pT16": `MonthItem-module__p-t-16___eb5le`,
	"pT18": `MonthItem-module__p-t-18___eeX23`,
	"pT20": `MonthItem-module__p-t-20___C7jhW`,
	"pT30": `MonthItem-module__p-t-30___q2zyi`,
	"pT40": `MonthItem-module__p-t-40___Pb5ri`,
	"pT50": `MonthItem-module__p-t-50___olj2R`,
	"pL20": `MonthItem-module__p-l-20___ntvLb`,
	"pL30": `MonthItem-module__p-l-30___nToPk`,
	"pL40": `MonthItem-module__p-l-40___kVDjp`,
	"pR16": `MonthItem-module__p-r-16___hCIb5`,
	"pR20": `MonthItem-module__p-r-20___u4US0`,
	"pR30": `MonthItem-module__p-r-30___XSAac`,
	"pR50": `MonthItem-module__p-r-50___WIyZe`,
	"pR60": `MonthItem-module__p-r-60___S7_5t`,
	"mB1": `MonthItem-module__m-b-1___gFb5t`,
	"mB2": `MonthItem-module__m-b-2___SX6aB`,
	"mB6": `MonthItem-module__m-b-6___wZ3R6`,
	"mB8": `MonthItem-module__m-b-8___MO2y3`,
	"mB10": `MonthItem-module__m-b-10___SOGiM`,
	"mB14": `MonthItem-module__m-b-14___d5MGx`,
	"mB16": `MonthItem-module__m-b-16___CfPqV`,
	"mB20": `MonthItem-module__m-b-20___yhNxM`,
	"mB22": `MonthItem-module__m-b-22___UUswA`,
	"mB24": `MonthItem-module__m-b-24___TowH9`,
	"mB30": `MonthItem-module__m-b-30___eQixV`,
	"mB32": `MonthItem-module__m-b-32___nPIem`,
	"mB40": `MonthItem-module__m-b-40___Gf49g`,
	"mT2": `MonthItem-module__m-t-2___UOPsT`,
	"mT3": `MonthItem-module__m-t-3___u689b`,
	"mT4": `MonthItem-module__m-t-4___bSs3s`,
	"mT5": `MonthItem-module__m-t-5___bowIo`,
	"mT8": `MonthItem-module__m-t-8___hCX5E`,
	"mT10": `MonthItem-module__m-t-10___iQLUz`,
	"mT15": `MonthItem-module__m-t-15___NE24E`,
	"mT16": `MonthItem-module__m-t-16___y1aGi`,
	"mT20": `MonthItem-module__m-t-20___ufv71`,
	"mT22": `MonthItem-module__m-t-22___YuqgK`,
	"mT30": `MonthItem-module__m-t-30___jP0h6`,
	"mT32": `MonthItem-module__m-t-32___UtqhJ`,
	"mLAuto": `MonthItem-module__m-l-auto___Dk7Wy`,
	"mL4": `MonthItem-module__m-l-4___Rhd2O`,
	"mL5": `MonthItem-module__m-l-5___Z_XSq`,
	"mL6": `MonthItem-module__m-l-6___NLfGu`,
	"mL8": `MonthItem-module__m-l-8___BXl6f`,
	"mL10": `MonthItem-module__m-l-10___M7rBK`,
	"mL16": `MonthItem-module__m-l-16___CqtHu`,
	"mL20": `MonthItem-module__m-l-20___ECljO`,
	"mL24": `MonthItem-module__m-l-24___pS7x1`,
	"mL30": `MonthItem-module__m-l-30___h_FzD`,
	"mL35": `MonthItem-module__m-l-35___RSqVo`,
	"mL40": `MonthItem-module__m-l-40___ARWUN`,
	"mR8": `MonthItem-module__m-r-8___kVDlv`,
	"mR10": `MonthItem-module__m-r-10___RE0zG`,
	"mR16": `MonthItem-module__m-r-16___M3tQo`,
	"mR20": `MonthItem-module__m-r-20___ozwCU`,
	"mR24": `MonthItem-module__m-r-24___osbuY`,
	"mR30": `MonthItem-module__m-r-30___THEQ9`,
	"mR40": `MonthItem-module__m-r-40___Z3P_B`,
	"borderR3": `MonthItem-module__border-r-3___qKBvk`,
	"borderR4": `MonthItem-module__border-r-4___qQZKD`,
	"borderR6": `MonthItem-module__border-r-6___n34vv`,
	"borderR10": `MonthItem-module__border-r-10___j6isk`,
	"borderR12": `MonthItem-module__border-r-12___th6nA`,
	"borderR16": `MonthItem-module__border-r-16___ESsFB`,
	"borderR50": `MonthItem-module__border-r-50___GXEN_`,
	"primaryBorder": `MonthItem-module__primary-border___QYnnj`,
	"primaryBorderB": `MonthItem-module__primary-border-b___AwTe0`,
	"primaryBorderT": `MonthItem-module__primary-border-t___GNTQm`,
	"primaryBorderL": `MonthItem-module__primary-border-l___tTarM`,
	"primaryBorderR": `MonthItem-module__primary-border-r___Hs6Ne`,
	"secondaryBorder": `MonthItem-module__secondary-border___AGm5J`,
	"secondaryBorderB": `MonthItem-module__secondary-border-b___NyVc1`,
	"secondaryBorderT": `MonthItem-module__secondary-border-t___oWa8E`,
	"secondaryBorderL": `MonthItem-module__secondary-border-l___Sd6w2`,
	"secondaryBorderR": `MonthItem-module__secondary-border-r___REDNF`,
	"gap0": `MonthItem-module__gap-0___sslJH`,
	"gap2": `MonthItem-module__gap-2___RpqM6`,
	"gap4": `MonthItem-module__gap-4___BEnMZ`,
	"gap5": `MonthItem-module__gap-5___Ze6Ge`,
	"gap6": `MonthItem-module__gap-6___eS_0Q`,
	"gap8": `MonthItem-module__gap-8___ozYBK`,
	"gap10": `MonthItem-module__gap-10___UXZAV`,
	"gap12": `MonthItem-module__gap-12___EUH8D`,
	"gap14": `MonthItem-module__gap-14___DAgbR`,
	"gap16": `MonthItem-module__gap-16___jxxIg`,
	"gap18": `MonthItem-module__gap-18___tB136`,
	"gap20": `MonthItem-module__gap-20___mfI1_`,
	"gap24": `MonthItem-module__gap-24___T9Dt3`,
	"gap26": `MonthItem-module__gap-26___KdlXt`,
	"gap30": `MonthItem-module__gap-30___k6Zvw`,
	"gap32": `MonthItem-module__gap-32___O_FED`,
	"gap40": `MonthItem-module__gap-40___fmBPR`,
	"gap50": `MonthItem-module__gap-50___gUmXF`,
	"flex1": `MonthItem-module__flex-1___dASnh`,
	"flexNone": `MonthItem-module__flex-none___SsuNi`,
	"flexColumn": `MonthItem-module__flex-column___ytLdq`,
	"flexRow": `MonthItem-module__flex-row___RQesn`,
	"verticallyCentered": `MonthItem-module__vertically-centered___TeEW9`,
	"horizontallyCentered": `MonthItem-module__horizontally-centered___kqzsp`,
	"horizontallyEnd": `MonthItem-module__horizontally-end___duTnX`,
	"verticallyStart": `MonthItem-module__vertically-start___KCEFU`,
	"spaceBetween": `MonthItem-module__space-between___o9XW2`,
	"flexWrap": `MonthItem-module__flex-wrap___ELxPF`,
	"height100": `MonthItem-module__height-100___wcUwb`,
	"width50": `MonthItem-module__width-50___lgm64`,
	"width100": `MonthItem-module__width-100___hTOSq`,
	"cursorPointer": `MonthItem-module__cursor-pointer___YK0Wl`,
	"cursorNotAllowed": `MonthItem-module__cursor-not-allowed___qTQp0`,
	"absoluteCentered": `MonthItem-module__absolute-centered___v0FD4`,
	"absolute": `MonthItem-module__absolute___E27Gg`,
	"relative": `MonthItem-module__relative___goBhR`,
	"fixed": `MonthItem-module__fixed___BOsF2`,
	"visible": `MonthItem-module__visible___IichU`,
	"invisible": `MonthItem-module__invisible___Axxt3`,
	"col90": `MonthItem-module__col-90___ohpEA`,
	"colAuto": `MonthItem-module__col-auto___RQX0D`,
	"medicalTabs": `MonthItem-module__medical-tabs___e6MDi`,
	"medicalTableNew": `MonthItem-module__medical-table-new___oZGtR`,
	"noPagination": `MonthItem-module__no-pagination___YAEPj`,
	"medicalTableEmpty": `MonthItem-module__medical-table-empty___lhaah`,
	"iconBtn": `MonthItem-module__icon-btn___vy6Lv`,
	"searchIcon": `MonthItem-module__search-icon___iipXX`,
	"disableSelect": `MonthItem-module__disable-select___xUVWl`,
	"breakWord": `MonthItem-module__break-word___sWpfh`,
	"popupClearBtn": `MonthItem-module__popup-clear-btn___jPiGs`,
	"scrollMB20": `MonthItem-module__scroll-m-b-20___PvYIT`,
	"item": `MonthItem-module__item___OZvPi`,
	"circle": `MonthItem-module__circle___hD_yo`,
	"fill": `MonthItem-module__fill___HjR29`,
	"month": `MonthItem-module__month___MpGYm`
};
module.exports = ___CSS_LOADER_EXPORT___;
